import { thanos26GetJson } from "./thanos26Client";

async function getAllCustomerData(): Promise<any> {
    return thanos26GetJson("manager/Summary");
}

export default { getAllCustomerData };
